<script setup lang="ts">
import { ref } from 'vue'
import type { HoldGoldRankType } from '@/types/rank'
import { socketEmitAsync } from '@/utils/web-socket'
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import { onMounted } from 'vue'
import { formatNumberWithCommas } from '@/utils'

const commonStore = useCommonStore()
const userStore = useUserStore()

const rankList = ref<HoldGoldRankType[]>([])
async function getFightDamageRank() {
  const res = await socketEmitAsync<HoldGoldRankType[]>({ type: 'getHoldGoldRank' })
  rankList.value = res
}

onMounted(() => {
  getFightDamageRank()
})
</script>

<template>
  <el-table
    :data="rankList"
    border
    style="width: 100%; height: 100%"
    :row-class-name="({ row }: any) => (row.id === userStore.id ? 'personal' : '')"
    size="small"
    v-loading="commonStore.loading"
  >
    <el-table-column prop="rank" label="排位" width="50"> </el-table-column>
    <el-table-column prop="nickname" label="昵称">
      <template #default="{ row }">
        <span class="nickname" :style="{ background: row.color }">{{ row.nickname }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="gold" label="持有金币" width="120">
      <template #default="{ row }">
        <span>{{ formatNumberWithCommas(row.gold) }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<style lang="scss" scoped></style>
